"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TimingEventAction = exports.TimingEventType = void 0;
var TimingEventType;
(function (TimingEventType) {
    TimingEventType["COLLECTION"] = "COLLECTION";
    TimingEventType["DATE"] = "DATE";
    TimingEventType["DEBUG"] = "DEBUG";
    TimingEventType["HEIGHT"] = "HEIGHT";
    TimingEventType["IMAGE"] = "IMAGE";
    TimingEventType["LOCATION"] = "LOCATION";
    TimingEventType["NAVIGATION"] = "NAVIGATION";
    TimingEventType["NESTED_LIST"] = "NESTED_LIST";
    TimingEventType["NUMBER"] = "NUMBER";
    TimingEventType["IKE_PHOTO"] = "IKE_PHOTO";
    TimingEventType["PHOTOMEASURE"] = "PHOTOMEASURE";
    TimingEventType["TOPOLOGICAL_EDITOR"] = "TOPOLOGICAL_EDITOR";
    TimingEventType["SELECT_LIST"] = "SELECT_LIST";
    TimingEventType["SUBFORM"] = "SUBFORM";
    TimingEventType["TEXT"] = "TEXT";
    TimingEventType["UPLOAD"] = "UPLOAD";
    TimingEventType["VECTOR"] = "VECTOR";
    TimingEventType["YES_NO"] = "YES_NO";
    TimingEventType["HOA"] = "HOA";
})(TimingEventType || (exports.TimingEventType = TimingEventType = {}));
var TimingEventAction;
(function (TimingEventAction) {
    TimingEventAction["BACK"] = "BACK";
    TimingEventAction["CANCEL"] = "CANCEL";
    TimingEventAction["CAPTURE"] = "CAPTURE";
    TimingEventAction["DELETE"] = "DELETE";
    TimingEventAction["EDIT"] = "EDIT";
    TimingEventAction["ENTER"] = "ENTER";
    TimingEventAction["EXIT"] = "EXIT";
    TimingEventAction["MENU"] = "MENU";
    TimingEventAction["REVIEW"] = "REVIEW";
    TimingEventAction["SELECT"] = "SELECT";
    TimingEventAction["UPLOAD"] = "UPLOAD";
    TimingEventAction["EXPORT"] = "EXPORT";
})(TimingEventAction || (exports.TimingEventAction = TimingEventAction = {}));
//# sourceMappingURL=timing.js.map